module.exports = __webpack_public_path__ + "img/主营业务_系统节能改造03.c6c39376.png";